export const Home = '/';
export const About = '/about';
export const Dashboard = '/dashboard';
export const Contact = '/contact';
export const Sports = '/sports';
export const OurResults = '/ourresults';
export const Login = '/login';
export const Register = '/register';
export const Athlete = '/athlete';
export const Parent = '/parents';
export const Coach = '/coach';
export const AthleteCoachView = '/coach/athlete';
export const RegisterAthlete = '/register/athlete';
export const ViewAthlete = '/view/athlete';
export const ViewAthleteById = '/view/athlete/:profileId';
export const Forgot = '/forgot';
export const Settings = '/settings';
export const CoachRegister = '/register/coach';
export const CoachProfile = '/view/coach';
export const CoachDashboard = '/view/coach/dashboard';
export const Pricing = '/pricing';
export const Payment = '/checkout';
export const RedirectPage = '/redirect';
export const RegisterParent = '/register/parent';
export const Support = '/admin/admin_portal_support';
export const AdminLogin = '/admin/admin_portal_login';
export const VerifyCoach = '/verify_coach';
export const AdminBase = '/admin/admin_portal';
export const Terms = '/terms_and_use';
export const AthleteForCoach = '/athleteForCoach';
export const PublicAthlete = '/sendSaContactToCoach';



// WEBPACK FOOTER //
// ./src/common/routes/routeNames.js